import { render, staticRenderFns } from "./MarginSalesReport.vue?vue&type=template&id=3b9ca53c&"
import script from "./MarginSalesReport.vue?vue&type=script&lang=js&"
export * from "./MarginSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports